import { useCallback, useEffect, useRef, useState } from 'react'

import { MODULE_ADDRESS } from 'config'

import { useCommonConnectStore } from 'components/WalletProvider/store'

const fn = `${MODULE_ADDRESS}::claim::get_total_claimed`

const useGetTotalClaimed = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [totalClaimed, setTotalClaimed] = useState('0')
  const prevClaimTimestampRef = useRef<null | number>(null)
  const { claimUpdateTimestamp, client } = useCommonConnectStore((state) => state)

  const fetchTotalClaimed = useCallback(() => {
    setIsLoading(true)
    client
      .view({ arguments: [], function: fn, type_arguments: [] })
      .then((data: string[]) => {
        setTotalClaimed(data[0])
      })
      .catch((error) => {
        console.error('Failed to fetch total claimed:', error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [client])

  useEffect(() => {
    if (client) {
      prevClaimTimestampRef.current = Date.now()
      fetchTotalClaimed()
    }
  }, [client, fetchTotalClaimed])

  useEffect(() => {
    const shouldFetch =
      client &&
      claimUpdateTimestamp &&
      prevClaimTimestampRef.current &&
      claimUpdateTimestamp !== prevClaimTimestampRef.current
    if (shouldFetch) {
      prevClaimTimestampRef.current = Date.now()
      fetchTotalClaimed()
    }
  }, [claimUpdateTimestamp, client, fetchTotalClaimed])

  return { isLoading, totalClaimed }
}
export default useGetTotalClaimed
